import { get, post, patch, del } from '@/lib/api';

export interface ApiKey {
  id: string;
  name: string;
  keyPrefix: string;
  lastUsedAt: string | null;
  revokedAt: string | null;
  createdAt: string;
}

export interface ApiKeyCreated {
  id: string;
  name: string;
  keyPrefix: string;
  createdAt: string;
  secret: string; // показывается один раз
}

export type WebhookEvent = 'order.created' | 'order.updated';

export interface Webhook {
  id: string;
  url: string;
  events: WebhookEvent[];
  isActive: boolean;
  failureCount: number;
  lastStatus: number | null;
  lastError: string | null;
  lastDeliveryAt: string | null;
  createdAt: string;
}

export interface WebhookCreated {
  id: string;
  url: string;
  events: WebhookEvent[];
  isActive: boolean;
  createdAt: string;
  secret: string; // показывается один раз
}

export interface WebhookTestResult {
  ok: true;
  lastStatus: number | null;
  lastError: string | null;
  lastDeliveryAt: string | null;
}

/** Строка журнала обмена: один запрос 1С и наш ответ на него. */
export interface ErpLog {
  id: string;
  keyName: string | null;
  method: string;
  path: string;
  query: string | null;
  status: number;
  durationMs: number;
  /** Сколько одинаковых успешных чтений схлопнуто в эту строку. */
  repeatCount: number;
  requestBody: string | null;
  responseBody: string | null;
  /** Тело обрезано — в журнале лежит только начало. */
  truncated: boolean;
  ip: string | null;
  userAgent: string | null;
  firstAt: string;
  createdAt: string;
}

export interface ErpLogPage {
  results: ErpLog[];
  /** Курсор для «показать ещё»; null — дальше пусто. */
  nextBefore: string | null;
  problemsLast24h: number;
}

export const listErpLogs = (params: { before?: string; onlyProblems?: boolean } = {}) => {
  const qs = new URLSearchParams();
  if (params.before) qs.set('before', params.before);
  if (params.onlyProblems) qs.set('onlyProblems', 'true');
  const tail = qs.toString();
  return get<ErpLogPage>(`/erp-logs${tail ? `?${tail}` : ''}`);
};

export const listApiKeys = () => get<ApiKey[]>('/api-keys');
export const createApiKey = (name: string) => post<ApiKeyCreated>('/api-keys', { name });
export const deleteApiKey = (id: string) => del<{ ok: true }>(`/api-keys/${id}`);

export const listWebhooks = () => get<Webhook[]>('/webhooks');
export const createWebhook = (body: { url: string; events?: WebhookEvent[] }) =>
  post<WebhookCreated>('/webhooks', body);
export const updateWebhook = (
  id: string,
  body: { url?: string; events?: WebhookEvent[]; isActive?: boolean },
) => patch<Webhook>(`/webhooks/${id}`, body);
export const deleteWebhook = (id: string) => del<{ ok: true }>(`/webhooks/${id}`);
export const testWebhook = (id: string) => post<WebhookTestResult>(`/webhooks/${id}/test`);
